module.exports = __webpack_public_path__ + "static/tokr-email-178f15b0a5f810ef3164f8478d88d422.jpg";